import Statistics from './Statistics';

export default Statistics;



// WEBPACK FOOTER //
// ./src/components/Statistics/index.js